import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import './textField.css';

interface CareMapprTextFieldProps {
  label?: string;
  labelClassName?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  className?: string;
  inputClassName?: string;
  controlId?: string;
  required?: boolean;
  disabled?: boolean;
}
const CareMapprTextField = ({
  label,
  labelClassName = '',
  value,
  onChange,
  placeholder = '',
  type = 'text',
  className = '',
  controlId = 'text-field',
  required = false,
  disabled = false,
  inputClassName = '',
  ...props
}: CareMapprTextFieldProps) => {
  return (
    <Form.Group controlId={controlId} className={className}>
      {label && (
        <Form.Label className={`ellipsis ${labelClassName}`}>
          {label}
        </Form.Label>
      )}
      <InputGroup>
        <Form.Control
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          className={inputClassName}
          {...props}
        />
      </InputGroup>
    </Form.Group>
  );
};
export default CareMapprTextField;
